export default "__VITE_ASSET__Cao7DYyu__"